export function logError(error: unknown) {
  return console.error(error);
}
